module.exports = __webpack_public_path__ + "static/media/Overtime.9ba39b8f.svg";